import _ from 'lodash';
import { isAlwaysAvailable, AvailabilityIterator } from 'availability';
import { unionIntervals } from 'interval-utils';
import moment from 'moment-timezone';
export function unionWeeklyAvailabilities(availabilities) {
    if (availabilities.some(alwaysAvailable)) {
        return { weekly: [{ minuteOfWeek: 0, durationMins: 10080 }] };
    }
    var intervals = availabilities
        .map(availabilityToWeekly)
        .map(weeklyAvailabilityToIntervals);
    var unionizedInterval = unionIntervals.apply(void 0, intervals);
    return {
        weekly: intervalsToAvailability(unionizedInterval),
    };
}
export function unionAvailabilityExceptions(availabilities) {
    return availabilities.flatMap(function (a) { return a.exceptions || []; }).filter(Boolean);
}
function availabilityToWeekly(availability) {
    return availability && availability.weekly ? availability.weekly : [];
}
function weeklyAvailabilityToIntervals(weekly) {
    return _.map(weekly, availabilityRangeToInterval);
}
function availabilityRangeToInterval(_a) {
    var minuteOfWeek = _a.minuteOfWeek, durationMins = _a.durationMins;
    return [minuteOfWeek, minuteOfWeek + durationMins];
}
function intervalsToAvailability(intervals) {
    return _.map(intervals, function (_a) {
        var from = _a[0], to = _a[1];
        return ({
            minuteOfWeek: from,
            durationMins: to - from,
        });
    });
}
function alwaysAvailable(availability) {
    return (typeof availability.weekly === 'undefined' ||
        isAlwaysAvailable(new AvailabilityIterator({ availability: availability, cal: moment() })));
}
//# sourceMappingURL=unionAvailabilites.js.map